export default __webpack_public_path__ + "static/media/thumbnail-opportunity-new.b44b99bd.png";